import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import { UiServices } from 'src/app/services/ui-services';
import { Lesson, TestItem } from 'src/app/pages/virtual-class/interfaces';
import { ModuleTestService } from '../../../services/module-test.service';

@Component({
  selector: 'app-class-card',
  templateUrl: './class-card.component.html',
  styleUrls: ['./class-card.component.scss'],
})
export class ClassCardComponent implements OnInit {
  @Input() lesson?: Lesson | TestItem;
  @Input() inscriptionId: string = '';
  @Input() isTest = false;
  @Input() showArrow: boolean = true;

  constructor(
    private navCtrl: NavController,
    private route: ActivatedRoute,
    private uiSv: UiServices,
    private moduleTestSv: ModuleTestService
  ) {}

  ngOnInit() {}

  async goToClass() {
    const inscriptionId = this.route.snapshot.paramMap.get('incription_id');
    if (this.lesson.canView === 0) {
      this.moduleTestSv.showReasonModal(this.lesson as TestItem, inscriptionId);
      return;
    }
    const route = this.isTest ? 'test' : 'class';

    if (route === 'test') {
      const { role } = await this.uiSv.presentAlert(
        '¿Estás seguro que deseas iniciar el examen?',
        true
      );
      if (role !== 'accept') {
        return;
      }
    }
    this.navCtrl.navigateForward(
      `virtual-class/${route}/${this.inscriptionId}/${this.lesson.id}`,
      {
        relativeTo: this.route,
      }
    );
  }
}
